import React from 'react';
import styled from 'styled-components';

const handleColorType = (module, theme) => {
	switch (module) {
		case 'storage':
			return theme?.theme?.storage;
		case 'account':
			return theme?.theme?.account;
		case 'billing':
			return theme?.theme?.billing;
		case 'support':
			return theme?.theme?.support;
		default:
			return theme?.theme?.main;
	}
};

const BarSVG = styled.svg`
	width: 14px;
	height: 14px;
	//margin-left: 3px;

	.bar,
	.bar-1,
	.bar-2,
	.bar-3 {
		fill: #a2a9ad;
	}
`;

export const BarSelector = props => {
	const { id, theme, module, className, onClick } = props;

	return (
		<BarSVG
			id={id}
			module={module}
			x='0px'
			y='0px'
			viewBox='0 0 16 16'
			onClick={onClick}
			//style='enable-background:new 0 0 512 512;'
		>
			<defs>
				<linearGradient
					id={`${id}-swipe-gradient`}
					x1='0.5'
					y1='1'
					x2='0.5'
					y2='-2'
					gradientTransform='rotate(270)'
				>
					<stop offset='0' stop-color='white'>
						<animate
							id={`${id}trans1`}
							dur='0.7s'
							attributeName='offset'
							fill='freeze'
							from='0'
							to='1'
							restart='always'
							begin='indefinite'
						/>
					</stop>
					<stop offset='0' stop-color={handleColorType(module, theme)}>
						<animate
							id={`${id}trans1`}
							dur='0.7s'
							attributeName='offset'
							fill='freeze'
							from='0'
							to='1'
							restart='always'
							begin='indefinite'
						/>
					</stop>
				</linearGradient>
			</defs>
			<path
				id='chart-bar'
				class={className}
				d='M16,17H2V3H3.4V15.444H4.8v-7H7.6v7H9V5.333h2.8V15.444h1.4V11.556H16Z'
				transform='translate(-2 -3)'
			/>
			{/* <g>
				<g>
					<path
						class={className}
						d='M117.547,234.667H10.88c-5.888,0-10.667,4.779-10.667,10.667v256C0.213,507.221,4.992,512,10.88,512h106.667
			c5.888,0,10.667-4.779,10.667-10.667v-256C128.213,239.445,123.456,234.667,117.547,234.667z'
					/>
				</g>
			</g> */}
			{/* <g>
				<g>
					<path
						class={className}
						d='M309.12,0H202.453c-5.888,0-10.667,4.779-10.667,10.667v490.667c0,5.888,4.779,10.667,10.667,10.667H309.12
			c5.888,0,10.667-4.779,10.667-10.667V10.667C319.787,4.779,315.008,0,309.12,0z'
					/>
				</g>
			</g>
			<g>
				<g>
					<path
						class={className}
						d='M501.12,106.667H394.453c-5.888,0-10.667,4.779-10.667,10.667v384c0,5.888,4.779,10.667,10.667,10.667H501.12
			c5.888,0,10.667-4.779,10.667-10.667v-384C511.787,111.445,507.008,106.667,501.12,106.667z'
					/>
				</g>
			</g> */}
			<g></g>
			<g></g>
			<g></g>
			<g></g>
			<g></g>
			<g></g>
			<g></g>
			<g></g>
			<g></g>
			<g></g>
			<g></g>
			<g></g>
			<g></g>
			<g></g>
			<g></g>
		</BarSVG>
	);
};
